module.exports = __webpack_public_path__ + "static/img/file_avi.80aa4b45.png";